import * as yup from "yup";
import "./minNotRequired";

export default yup;
